import React from 'react';
import PropTypes from 'prop-types';
import useSearchHandler from 'hooks/useSearchHandler';

/**
 * Basic Search Handler for search box
 */
const withSearchHandler = (Component) => {
	const WithSearchHandler = (props) => {
		const handleSearch = useSearchHandler({
			searchType: props.searchType,
			additionalSearchParams: props.additionalSearchParams,
			type: props.type,
			location: props.location,
		});

		return (
			<Component
				{...props}
				handleSearch={handleSearch}
			/>
		);
	};
	WithSearchHandler.propTypes = {
		searchType: PropTypes.string,
		additionalSearchParams: PropTypes.object,
		type: PropTypes.string,
		location: PropTypes.object,
	};
	WithSearchHandler.displayName = `withSearchHandler(${Component.displayName || Component.name || 'Component'})`;
	return WithSearchHandler;
};

export default withSearchHandler;
